"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerProductWidget = void 0;
function registerProductWidget(props) {
    WidgetFramework.WidgetManager.registerProductWidget(function (pidget) {
        props.load({ pidget: pidget });
    });
}
exports.registerProductWidget = registerProductWidget;
